import { OktaAuth } from '@okta/okta-auth-js'

const OKTA_PREVIEW_STORAGE_KEY = 'okta-preview'
const OKTA_PREVIEW_DOMAIN = 'natera-ext.oktapreview.com'

const OKTA_PREVIEW_CLIENT_ID = '0oa2e7a35yc5zOV6X0h8'

export function isOktaPreview(): boolean {
  return localStorage.getItem(OKTA_PREVIEW_STORAGE_KEY) === 'true'
}

export function setOktaPreview(value: boolean): void {
  if (value) {
    localStorage.setItem(OKTA_PREVIEW_STORAGE_KEY, 'true')
  } else {
    localStorage.removeItem(OKTA_PREVIEW_STORAGE_KEY)
  }
}

export function createOktaPreviewAuth(): OktaAuth {
  return new OktaAuth({
    issuer: `https://${OKTA_PREVIEW_DOMAIN}/oauth2/default`,
    clientId: OKTA_PREVIEW_CLIENT_ID,
    redirectUri: window.location.origin + '/login/callback',
    logoutUrl: window.location.origin + '/login',
  })
}

if (import.meta.env.VITE_DEPLOYMENT_STAGE !== 'dev') {
  localStorage.removeItem(OKTA_PREVIEW_STORAGE_KEY)
}

const usePreview = import.meta.env.VITE_DEPLOYMENT_STAGE === 'dev' && isOktaPreview()
const domain = usePreview ? OKTA_PREVIEW_DOMAIN : import.meta.env.VITE_OKTA_DOMAIN
const clientId = usePreview ? OKTA_PREVIEW_CLIENT_ID : import.meta.env.VITE_OKTA_CLIENT_ID

try {
  const storedTokens = JSON.parse(localStorage.getItem('okta-token-storage') || '{}')
  const storedIssuer = storedTokens?.idToken?.claims?.iss
  if (storedIssuer && !storedIssuer.startsWith(`https://${domain}/`)) {
    localStorage.removeItem('okta-token-storage')
    localStorage.removeItem('okta-cache-storage')
  }
} catch {
  localStorage.removeItem('okta-token-storage')
  localStorage.removeItem('okta-cache-storage')
}

export const oktaAuth = new OktaAuth({
  issuer: `https://${domain}/oauth2/default`,
  clientId,
  redirectUri: window.location.origin + '/login/callback',
  logoutUrl: window.location.origin + '/login',
})
